import template from './leave_types.html';
import tr from '../../lib/default-translator.js';

class AdminLeaveTypesViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}

	goto_leave_restriction_page()
	{
		Grape.navigate('/admin/leave_rules');
	}

	goto_leave_category_page()
	{
		Grape.navigate('/admin/leave_categories');
	}

	show_leave_types_help()
	{
		Grape.dialog.open('LeaveTypesHelp', { 'employee_id': this.dialog.bindings.id });
	}
}

class AdminLeaveTypesPage
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.viewModel = new AdminLeaveTypesViewModel(this);
	}

	init()
	{
		document.title = tr('Manage Leave Types');
		window.current_page_title(tr('Add/Edit Leave Types'));
	}
}

export default {
	route: '[/]admin/leave_types',
	page_class: AdminLeaveTypesPage,
	template: template,
	template_filename: 'translation/leave_types',
	provider: 'ps'
};
